import setAsyncState from '@functions/setAsyncState.ts';
import ArticleT from '@global/models/Article.ts';
import getListItems from '@requests/getListItems.ts';

import I from '../types.ts';

const getArticle: I['getArticle'] = async function () {
    const { url } = this.props;

    try {
        const { item } = await getListItems<ArticleT>({
            url: 'article',
            query: [
                { key: 'type', value: 'legal' },
                { key: 'system', value: 'crm' },
                { key: 'url', value: url },
            ],
        });

        await setAsyncState.call(this, { article: item });

        this.setHeight();
    } catch (error) {}
};

export default getArticle;
